import React from "react";

const Watermark = () => {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10 pointer-events-none">
      <img  
        src="/dca1.png"  // Change this to the correct image path
        alt="Watermark"
        className="w-40 h-40 object-contain"  // Adjust size as needed
      />
    </div>
  );
};

export default Watermark;
